import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import IconPen from 'components/icons/IconPen';
import ClaimStatusCreateEditDialog from 'components/settings/ClaimStatusCreateEditDialog';
import Link from 'components/common/Link';
import Chip from 'components/common/Chip';

import splitLongWords from 'utils/splitLongWords';

import { deleteDocumentCategory } from 'redux/modules/documentCategories';

const styles = theme => ({
  iconMoreVert: {
    width: 24,
    height: 24,
  },
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  cellPhone: {
    whiteSpace: 'nowrap',
  },
  iconPen: {
    width: 16,
    height: 16,
  },
  linkStatus: {
    textTransform: 'capitalize',
  },
  cellCategory: {
    fontWeight: 'bold',
  },
  cellCategorySent: {
    color: theme.palette.notification['500'],
  },
  cellCategorySuccess: {
    color: theme.palette.add['500'],
  },
  cellCategoryError: {
    color: theme.palette.validation['500'],
  },
});

class ClaimStatusesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      deleteMenuOpen: false,
      editDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onDeleteMenuItemClick = this.onDeleteMenuItemClick.bind(this);
    this.onDeleteCancel = this.onDeleteCancel.bind(this);
    this.onDeleteSubmit = this.onDeleteSubmit.bind(this);
    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
      deleteMenuOpen: false,
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onEditMenuItemClick() {
    this.setState({
      anchorEl: null,
      editDialogOpen: true,
    });
  }

  onDeleteMenuItemClick() {
    this.setState({ deleteMenuOpen: true });
  }

  onDeleteCancel() {
    this.setState({ anchorEl: null });
  }

  onDeleteSubmit() {
    const { ID, actions } = this.props;
    actions.deleteDocumentCategory({ ID });
    this.setState({
      deleteMenuOpen: false,
      anchorEl: null,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { account, Status, Category, theme, classes } = this.props;
    const { anchorEl, deleteMenuOpen, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);

    return (
      <TableRow>
        <TableCell>
          <Link
            className={classes.linkStatus}
            breakWord
            onClick={this.onEditMenuItemClick}
          >
            {splitLongWords(Status)}
          </Link>
        </TableCell>
        <TableCell
          className={classNames(classes.cellCategory, {
            [classes.cellCategorySent]: Category === 'Sent',
            [classes.cellCategorySuccess]: Category === 'Success',
            [classes.cellCategoryError]: Category === 'Error',
          })}
        >
          {Category}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            onClick={this.onEditMenuItemClick}
            tooltipContent="Edit"
          >
            <IconPen className={classes.iconPen} />
          </IconButton>
        </TableCell>
        <ClaimStatusCreateEditDialog
          form={`claimStatusEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            Status,
            Category,
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

ClaimStatusesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  Status: PropTypes.string.isRequired,
  Category: PropTypes.string,
  actions: PropTypes.shape({
    deleteDocumentCategory: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    iconMoreVert: PropTypes.string.isRequired,
    buttonCell: PropTypes.string.isRequired,
    cellPhone: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimStatusesTableRow.defaultProps = {
  'Contact Person': null,
  'Mobile Phone': null,
  Email: null,
  'Create At': null,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ deleteDocumentCategory }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ClaimStatusesTableRow),
);



// WEBPACK FOOTER //
// ./src/components/settings/ClaimStatusesTable/ClaimStatusesTableRow.js